import React, { useState } from 'react';
import { Card, Grid } from 'antd';
import { EditOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PatientSummary from './PatientSummary';
import PatientForm from './PatientForm';
import PatientActions from './PatientActions';
import LinkButton from '../buttons/LinkButton';
import { logEvent } from '../../analytics';

const { useBreakpoint } = Grid;

const PatientHeader = ({ 
  patient, 
  onCallEnded,
  onPatientUpdate 
}) => {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const [editing, setEditing] = useState(false);

  const handleEdit = () => {
    logEvent('PatientDetails', 'Edit');
    setEditing(true);
  };

  const handleSave = (updated) => {
    onPatientUpdate(updated);
    setEditing(false);
  };

  const cardTitle = (
    <div
      style={{
        padding: '15px 0',
        display: 'flex',
        flexDirection: screens.md ? 'row' : 'column',
        alignItems: screens.md ? 'center' : 'stretch',
        justifyContent: 'space-between',
        gap: screens.md ? 8 : 0,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <UserOutlined style={{ marginRight: 8 }} />
        <span
          data-testid="patient-name"
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: screens.md ? 500 : '100%',
            display: 'inline-block',
          }}
        >
          {patient.getFullName()}
        </span>
        <LinkButton
          onClick={handleEdit}
          style={{ marginLeft: screens.md ? 10 : 0 }}
          buttonProps={{ icon: <EditOutlined /> }}
        >
          {t('patient_details.edit')}
        </LinkButton>
      </div>
      <PatientActions 
        patient={patient}
        onCallEnded={onCallEnded}
        onPatientUpdate={onPatientUpdate}
      />
    </div>
  );

  return (
    <>
      <Card title={cardTitle} bordered>
        <PatientSummary patient={patient} />
      </Card>

      <PatientForm
        isOpen={editing}
        onCancel={() => setEditing(false)}
        onSave={handleSave}
        editingPatient={patient}
      />
    </>
  );
};

export default PatientHeader; 